import { createSelector } from 'reselect';
import PredesComplianceMissingMandatoryElementsSummaryColumns
  from '../../containers/PredesComplianceMissingMandatoryElementsSummaryColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, PredesComplianceMissingMandatoryElementsSummaryColumns);
